import { Box, CircularProgress, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { ESRState } from "../../types/data";

export const Spinner = () => {
  const update_bulk_responses_in_progress = useSelector((state: ESRState) => state.update_bulk_responses_progress.inProgress);
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* MUI Spinner */}
        <CircularProgress size={64} sx={{ mb: 3 }} />

        {/* Animated Text */}
        {
          !update_bulk_responses_in_progress &&
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              color: 'text.secondary',
              fontFamily: 'monospace',
            }}
            className="typing-animation"
          >
            Fetching Details...
          </Typography>
        }
        {
          update_bulk_responses_in_progress &&
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              color: 'text.secondary',
              fontFamily: 'monospace',
            }}
          >
            Updating Responses...
        </Typography>
        }

        {/* Typing animation CSS */}
        <style>
          {`
            .typing-animation {
              display: inline-block;
              overflow: hidden;
              white-space: nowrap;
              border-right: 2px solid black;
              animation:
                typing 2s steps(20, end) infinite alternate,
                blink 0.7s step-end infinite;
            }

            @keyframes typing {
              from { width: 0 }
              to { width: 18ch }
            }

            @keyframes blink {
              0%, 100% { border-color: transparent }
              50% { border-color: black }
            }
          `}
        </style>
      </Box>
    </Box>
  );
};

